// @core/api/endpoints/payment/delete_payment_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/payment';

/**
 * Delete payment provider
 * Removes a payment provider. Active routes using this provider must be reassigned first.
 */
export async function DeletePaymentProvider(
  id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-providers/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
